// extracted by mini-css-extract-plugin
export var bodyTextCard = "index-module--bodyTextCard--d4aed";
export var bulletBox = "index-module--bulletBox--76459";
export var dreamImg = "index-module--dreamImg--ee8d5";
export var headingTextCard = "index-module--headingTextCard--8cc8e";
export var leftTriangle = "index-module--leftTriangle--6a0be";
export var rightTriangle = "index-module--rightTriangle--71b94";